export enum CaseTabs {
  Description = 0,
  Workflow = 1,
  Files = 2,
  Notes = 3,
  Communication = 4,
}
